import { IAuditNodeResponse } from '@alberta/konexi-shared';

export class AuditNodeResponse implements IAuditNodeResponse {
  value: string | any[] = '';
}
